<template>
  <div></div>
</template>

<script>
import { getAppVersionConfig } from '@/api/data'

export default {
  data() {
    return {
      downloadUrl: '',
      time: 0,
      time1: 0,
      time2: 0,
    }
  },
  created() {},
  mounted() {
    this.fetchData()
    this.submitFn()
  },
  methods: {
    async fetchData() {
      getAppVersionConfig('ysh_official_website_product').then((res) => {
        this.downloadUrl = res.data.data.fullUpdateInfo.downloadUrl
      })
    },

    submitFn() {
      //判断浏览器
      var u = navigator.userAgent
      if (/MicroMessenger/gi.test(u)) {
        // 引导用户在浏览器中打开
        alert('请在浏览器中打开')
        return
      }

      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        //Android
        this.openApp('yshapp://', 'Android')
      } else if (u.indexOf('iPhone') > -1) {
        //IOS
        this.openApp('yshapp://', 'ios')
      }
    },

    openApp(src, type) {
      let hasApp = true,
        t = 1000,
        t1 = Date.now()

      // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
      // 否则打开a标签的href链接
      var ifr = document.createElement('iframe')
      ifr.src = src
      ifr.style.display = 'none'
      document.body.appendChild(ifr)
      let that = this
      window.setTimeout(function () {
        if (!hasApp) {
          if (type == 'Android') {
            //由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
            alert('请下载APP')
            window.location.href = that.downloadUrl

            // var brand = that.judgeBrand(navigator.userAgent.toLowerCase()); //调用机型判断
            // // 默认从服务器下载
            // var consignorUrl = ""
            // // huawei
            // if (brand == 'huawei') {
            //     consignorUrl = "market://details?id=net.ysh.club";//xxx.xxx.xxx表示应用包名
            //     // OPPO
            // } else if (brand == 'oppo') {
            //     consignorUrl = "market://details?id=net.ysh.club";//xxx.xxx.xxx表示应用包名
            //     // vivo
            // } else if (brand == 'vivo') {
            //     consignorUrl = "market://details?id=net.ysh.club";//xxx.xxx.xxx表示应用包名
            //     // 小米
            // } else if (brand == 'xiaomi') {
            //     consignorUrl = "market://details?id=net.ysh.club";//xxx.xxx.xxx表示应用包名
            //     // 三星
            // } else if (brand == 'samsung') {
            //     consignorUrl = "market://details?id=net.ysh.club";//xxx.xxx.xxx表示应用包名
            //     // 默认
            // } else {

            // }
            // if (consignorUrl) {
            //     window.location.href = consignorUrl
            // }
          } else {
            alert('请下载APP')
            window.location.href = 'https://apps.apple.com/app/apple-store/id1631363552?pt=124916174&ct=home&mt=8'
          }
        }
        document.body.removeChild(ifr)
      }, 2000)

      this.openTimer = setTimeout(function () {
        //启动app时间较长处理
        let t2 = Date.now()

        that.time1 = t1
        that.time2 = t2
        if (t2 - t1 < t + 100) {
          that.time = t2 - t1
          hasApp = false
        }
      }, t)

      return hasApp
    },

    judgeBrand(sUserAgent) {
      var isIphone = sUserAgent.match(/iphone/i) == 'iphone'
      var isHuawei = sUserAgent.match(/huawei/i) == 'huawei'
      var isHonor = sUserAgent.match(/honor/i) == 'honor'
      var isOppo = sUserAgent.match(/oppo/i) == 'oppo'
      var isOppoR15 = sUserAgent.match(/pacm00/i) == 'pacm00'
      var isVivo = sUserAgent.match(/vivo/i) == 'vivo'
      var isXiaomi = sUserAgent.match(/mi\s/i) == 'mi '
      var isXiaomi2s = sUserAgent.match(/mix\s/i) == 'mix '
      var isRedmi = sUserAgent.match(/redmi/i) == 'redmi'
      var isSamsung = sUserAgent.match(/sm-/i) == 'sm-'

      // 如果为苹果环境
      if (isIphone) {
        return 'iphone'
        // 如果为华为环境
      } else if (isHuawei || isHonor) {
        return 'huawei'
        // 如果为OPPO环境
      } else if (isOppo || isOppoR15) {
        return 'oppo'
        // 如果为vivo环境
      } else if (isVivo) {
        return 'vivo'
        // 如果为小米环境
      } else if (isXiaomi || isRedmi || isXiaomi2s) {
        return 'xiaomi'
        // 如果为三星环境
      } else if (isSamsung) {
        return 'samsung'
      } else {
        return 'default'
      }
    },
  },
}
</script>


<style lang="less" scoped>
</style>
